import Fuse from "fuse.js";

export default {
  methods: {
    setupSites() {
      this.fuseSites = new Fuse(this.sites, {
        tokenize: true,
        matchAllTokens: true,
        findAllMatches: true,
        shouldSort: true,
        keys: ["name", "url", "Server.name", "Server.ip"],
        threshold: 0.3
      });
    },
    setupServers() {
      this.fuseServers = new Fuse(this.servers, {
        tokenize: true,
        matchAllTokens: true,
        findAllMatches: true,
        shouldSort: true,
        keys: ["name", "ip", "description", "Providers.name"],
        threshold: 0.3
      });
    },
    setupFinancial() {
      this.fuseServers = new Fuse(this.servers, {
        tokenize: true,
        matchAllTokens: true,
        findAllMatches: true,
        shouldSort: true,
        keys: ["name", "Providers.name"],
        threshold: 0.3
      });
    },
    setupProjects() {
      this.fuseProjects = new Fuse(this.projects, {
        tokenize: true,
        matchAllTokens: true,
        findAllMatches: true,
        shouldSort: true,
        keys: ["name", "Status.name", "description"],
        threshold: 0.3
      });
    },
    setupMaintenances() {
      this.fuseMaintenances = new Fuse(this.maintenances, {
        tokenize: true,
        matchAllTokens: true,
        findAllMatches: true,
        shouldSort: true,
        keys: ["name", "title", "description"],
        threshold: 0.3
      });
    },
    setupUsers() {
      this.fuseUsers = new Fuse(this.users, {
        tokenize: true,
        matchAllTokens: true,
        findAllMatches: true,
        shouldSort: true,
        keys: ["name", "email"],
        threshold: 0.3
      });
    },
    setupProviders() {
      this.fuseProviders = new Fuse(this.providers, {
        tokenize: true,
        matchAllTokens: true,
        findAllMatches: true,
        shouldSort: true,
        keys: ["name"],
        threshold: 0.3
      });
    },
    setupTypes() {
      this.fuseSiteTypes = new Fuse(this.siteTypes, {
        tokenize: true,
        matchAllTokens: true,
        findAllMatches: true,
        shouldSort: true,
        keys: ["type"],
        threshold: 0.3
      });
    }
  },
  computed: {
    filteredSites() {
      if (!this.fuseSites) return this.sites;
      return this.search.trim()
        ? this.fuseSites.search(this.search)
        : this.sites;
    },
    filteredServers() {
      if (!this.fuseServers) return this.servers;
      return this.search.trim()
        ? this.fuseServers.search(this.search)
        : this.servers;
    },
    filteredFinancial() {
      if (!this.fuseServers) return this.servers;
      return this.search.trim()
        ? this.fuseServers.search(this.search)
        : this.servers;
    },
    filteredProjects() {
      if (!this.fuseProjects) return this.projects;
      return this.search.trim()
        ? this.fuseProjects.search(this.search)
        : this.projects;
    },
    filteredMaintenances() {
      if (!this.fuseMaintenances) return this.maintenances;
      return this.search.trim()
        ? this.fuseMaintenances.search(this.search)
        : this.maintenances;
    },
    filteredUsers() {
      if (!this.fuseUsers) return this.users;
      return this.search.trim()
        ? this.fuseUsers.search(this.search)
        : this.users;
    },
    filteredProviders() {
      if (!this.fuseProviders) return this.providers;
      return this.search.trim()
        ? this.fuseProviders.search(this.search)
        : this.providers;
    },
    filteredTypes() {
      if (!this.fuseSiteTypes) return this.siteTypes;
      return this.search.trim()
        ? this.fuseSiteTypes.search(this.search)
        : this.siteTypes;
    }
  }
};
